import { BillingInfo } from 'types/Billing'
import { fetchUcs } from './fetchUcs'

/**
 * Retrieves the account entitlements from licenses
 */
export const getBillingInfo = (accountKey: string): Promise<BillingInfo> =>
  fetchUcs({
    path: `v3/accounts/${accountKey}/billinginfo`,
  })
